import React, { Component } from 'react'
import Event from './Event'
import RenderDelay from './../../components/render_delay/RenderDelay'
import LoadingIcon from './../../components/loading_icon/LoadingIcon'
import { getDatetime } from './../../utils/js/time_helpers'

import './Events.scss'

class Events extends Component {
    constructor() {
        super()
        this.state = {
            imagesLoaded: false,
        }
    }

    componentDidMount() {
        this.loadAllImages()
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.events.length !== this.props.events.length ||
            prevProps.dateTimestamp !== this.props.dateTimestamp
        ) {
            this.setState(
                {
                    imagesLoaded: false,
                },
                () => {
                    this.loadAllImages()
                }
            )
        }
    }

    loadAllImages = (index = 0) => {
        if (index >= this.props.events.length) return

        let event = this.props.events[index]
        let event_img = event.arena_background_image
            ? event.arena_background_image
            : event.promo_image
            ? event.promo_image
            : ''

        if (event_img === '') {
            if (this.props.events.length === index + 1) {
                this.setState({
                    imagesLoaded: true,
                })
            } else {
                this.loadAllImages(index + 1)
                return
            }
        }

        let image = new Image()
        image.src = event_img

        image.onload = () => {
            if (this.props.events.length === index + 1) {
                this.setState({
                    imagesLoaded: true,
                })
            } else {
                this.loadAllImages(index + 1)
                return
            }
        }

        // leave process if any error occurs
        image.onerror = () => {
            this.setState({
                imagesLoaded: true,
            })
        }
    }

    render() {
        const { events, channels, isFetching, dateTimestamp } = this.props

        return (
            <div className="Events__cont">
                {!isFetching &&
                    events &&
                    this.state.imagesLoaded &&
                    events.length !== 0 &&
                    events.map((event, i) => {
                        let delay = i * 0.05
                        return (
                            <Event
                                event={event}
                                channels={channels}
                                key={event.post_id}
                                aniDelay={delay}
                            />
                        )
                    })}
                {(isFetching || (!this.state.imagesLoaded && events && events.length !== 0)) && (
                    <RenderDelay>
                        <div className="loading_icon_container">
                            <LoadingIcon />
                            <div className="loading_text">Loading Events</div>
                        </div>
                    </RenderDelay>
                )}
                {!isFetching && events && events.length === 0 && (
                    <div className="noevents">
                        There are no scheduled events available for{' '}
                        {getDatetime(dateTimestamp, 'date')}
                    </div>
                )}
            </div>
        )
    }
}

export default Events
